import { render, staticRenderFns } from "./chat-window-item-content.vue?vue&type=template&id=65ca8fc1&scoped=true&"
import script from "./chat-window-item-content.vue?vue&type=script&lang=js&"
export * from "./chat-window-item-content.vue?vue&type=script&lang=js&"
import style0 from "./chat-window-item-content.vue?vue&type=style&index=0&id=65ca8fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca8fc1",
  null
  
)

export default component.exports